import { effect, inject, Injectable, signal } from '@angular/core';
import { getBrowserLang, TranslocoService } from '@jsverse/transloco';

export function getLang(): string {
  const browserLang = getBrowserLang();
  const storedLang = localStorage.getItem('lang');
  return storedLang ?? browserLang ?? 'en';
}

@Injectable()
export class I18nService {
  private readonly $transloco = inject(TranslocoService);
  language = signal<string>(getLang());

  constructor() {
    effect(() => {
      this.$transloco.setActiveLang(this.language());
      localStorage.setItem('lang', this.language());
    });
  }
}